import React, { PropsWithChildren } from 'react';

import { Redirect as StandardRedirect } from 'react-router-dom';

import { addQueryParamToUrl } from '../../helpers';
import { TRoutePaths, TRoutePathsWithParams, TRouteQuery } from '../../models';

type TRedirectProps<T extends TRoutePaths> = TRouteQuery<T> extends never
  ? {
      from?: TRoutePaths;
      to: TRoutePathsWithParams<T>;
      params?: never;
      exact?: boolean;
    }
  : {
      from?: TRoutePaths;
      to: TRoutePathsWithParams<T>;
      params?: TRouteQuery<T>;
      exact?: boolean;
    };

function Redirect<T extends TRoutePaths>({
  to,
  params,
  ...props
}: PropsWithChildren<TRedirectProps<T>>) {
  return <StandardRedirect {...props} to={addQueryParamToUrl(to, params)} />;
}

export default Redirect;
